module.exports = __webpack_public_path__ + "img/pre.19d921d3.png";